<template>
    <vue-scroll>
        <div class="page-header">
            <h1>Create Filler Article</h1>
        </div>
        <single style="max-width: 800px" />
    </vue-scroll>
</template>

<script>
import Single from "./Single";

export default {
    components: {
        Single,
    },
};
</script>

<style scoped></style>
